export default "__VITE_ASSET__CLGQTeeR__"